<template>
  <Main>
    <ToolsPanel
      :breadCrumbFirst="$t('nav.users')"
      :breadCrumbFirstLink="getFirstLink"
      :breadCrumbSecond="$t('user.editBreadcrumb')"
      :title="$t('user.editBreadcrumb')"
    >
      <div class="form-create__buttons">
        <MainButton buttonWhite @click.native="handleSubmit">Submit</MainButton>
        <MainButton @click.native="handleBackToList">Back</MainButton>
      </div>
    </ToolsPanel>
    <ContentContainer>
      <div class="form-create">
        <form @submit.prevent="handleSubmit">
          <template v-if="!bayer">
            <p class="form-create__label">Name</p>
            <div class="input-container">
              <InputText
                :set-value="formDataToSend"
                :id="'name'"
                :label="'name'"
                :type="'text'"
                :placeholder="'name'"
                :error-messages="validationErrors['name']"
                isBordered
              />
            </div>

            <p class="form-create__label">Email</p>
            <div class="input-container">
              <InputText
                :set-value="formDataToSend"
                :id="'email'"
                :label="'email'"
                :type="'text'"
                :placeholder="'email'"
                :error-messages="validationErrors['email']"
                isBordered
              />
            </div>

            <p class="form-create__label">Password</p>
            <div class="input-container">
              <InputText
                :set-value="formDataToSend"
                :id="'password'"
                :label="'password'"
                :type="'text'"
                :placeholder="'password'"
                :error-messages="validationErrors['password']"
                isBordered
              />
            </div>

            <template v-if="isCreateBayer() || formDataToSend.group == 3">
              <p class="form-create__label">Buyer Tag</p>
              <div class="input-container">
                <InputText
                  :set-value="formDataToSend"
                  :id="'buyer_tag'"
                  :label="'buyer_tag'"
                  :type="'text'"
                  :placeholder="'QQ11'"
                  :error-messages="validationErrors['buyerTag']"
                  :disabled="!can_edit_tag"
                  isBordered
                />
              </div>

              <p class="form-create__label">Facebook Accounts Id</p>
              <div
                v-for="(item, index) in formDataToSend.facebook_accounts"
                :key="index"
                class="input-container form-create__input-container"
              >
                <input
                  type="number"
                  class="form-create__input"
                  v-model="formDataToSend.facebook_accounts[index]"
                  @wheel.prevent
                  @paste="handlePaste($event, index)"
                />
                <div @click="deleteField(index)" class="form-create__delete-field">+</div>
                <Notification :error-messages="validationErrors[`facebookAccounts${index}`]" />
              </div>
              <div @click="addField" class="form-create__add-field">
                <span>+</span>
                Add field FD id
              </div>
            </template>

            <template v-if="admin && !isCreateBayer() && formDataToSend.group != 3">
              <p class="form-create__label">User Group</p>

              <div class="input-container checkbox-container checkbox-container_margin">
                <div class="checkbox-container__item">
                  <InputRadio
                    :set-value="formDataToSend"
                    :id="'group'"
                    :values="groupList"
                    :name="'name'"
                    :value="'id'"
                  />
                </div>
              </div>
            </template>
          </template>

          <template v-if="bayer">
            <p class="form-create__label">Facebook Accounts Id</p>

            <div @click="addFieldBayer" class="form-create__add-field">
              <span>+</span>
              Add field FD id
            </div>

            <div
              v-for="(item, index) in formDataToSend.facebook_accounts_add"
              :key="`${index}_1`"
              class="input-container form-create__input-container"
            >
              <input
                type="number"
                class="form-create__input"
                v-model="formDataToSend.facebook_accounts_add[index]"
                @wheel.prevent
                @paste="handlePasteAdd($event, index)"
              />
              <div @click="deleteFieldBayer(index)" class="form-create__delete-field">+</div>
              <Notification
                :error-messages="
                  validationErrors[
                    `facebookAccounts${index + formDataToSend.facebook_accounts.length}`
                  ]
                "
              />
            </div>

            <div
              v-for="(item, index) in formDataToSend.facebook_accounts"
              :key="index"
              class="input-container form-create__input-container"
            >
              <input
                type="number"
                class="form-create__input"
                v-model="formDataToSend.facebook_accounts[index]"
                @wheel.prevent
                @paste="handlePaste($event, index)"
              />
              <div @click="deleteField(index)" class="form-create__delete-field">+</div>
              <Notification :error-messages="validationErrors[`facebookAccounts${index}`]" />
            </div>
          </template>

          <div v-if="error.message != undefined" class="form-create__error">
            {{ error.message }}
          </div>
          <div class="form-create__btn">
            <MainButton :type="'submit'">Submit</MainButton>
          </div>
        </form>

        <ModalError
          :error-modal="false"
          :handle-close-error-modal="
            () => {
              this.error = {};
            }
          "
        />
      </div>
    </ContentContainer>
    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import userApi from "~/api/user";
import { getStoredUserInfo } from "~/helpers/userAuth";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import InputText from "~/components/atoms/inputs/InputText.vue";
import ModalError from "~/components/molecules/ModalError.vue";
import MainCheckbox from "~/components/atoms/inputs/MainCheckbox.vue";
import InputRadio from "~/components/atoms/inputs/InputRadio.vue";
import Notification from "~/components/molecules/Notification.vue";

export default {
  name: "UserEdit",
  metaInfo: {
    title: "User Edit",
  },
  data() {
    return {
      formDataToSend: {
        name: "",
        email: "",
        password: "",
        facebook_accounts: [],
        facebook_accounts_add: [],
        group: null,
        buyer_tag: "",
      },
      data: null,
      // FB-аккаунты, сохранённые на сервере на момент загрузки формы — чтобы понять, какие байер удалил крестиком
      initialFacebookAccounts: [],
      groupList: [],

      admin: false,
      team_lead: false,
      bayer: false,
      can_edit_tag: false,
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    InputText,
    ModalError,
    InputRadio,
    Notification,
  },
  computed: {
    ...mapState("users", ["error", "loadingProcess", "validationErrors"]),
    getFirstLink() {
      return ROUTE.USER_LIST.replace(":page", 1);
    },
    getId() {
      return this.$route.params.id;
    },
  },
  mounted() {
    if (getStoredUserInfo()) {
      this.user = getStoredUserInfo();
      if (
        this.user.groups[0].id == 2 ||
        this.user.groups[0].id == 6 ||
        this.user.groups[0].id == 5
      ) {
        this.admin = true;
      } else if (this.user.groups[0].id == 4) {
        this.team_lead = true;
      } else if (this.user.groups[0].id == 3) {
        this.bayer = true;
      }
      // тег байера меняют только Admin и Team Lead (Head/Shift — только просмотр)
      this.can_edit_tag = this.user.groups[0].id == 2 || this.user.groups[0].id == 4;
    }

    this.getItem();
    if (this.admin) {
      this.getGroup();
    }
  },
  methods: {
    isCreateBayer() {
      if (this.$route.query.team) {
        return true;
      }
      return false;
    },
    handleSubmit() {
      let fb;
      const url = `/${this.getId}`;
      if (this.formDataToSend.facebook_accounts_add.length) {
        fb = this.formDataToSend.facebook_accounts.concat(
          this.formDataToSend.facebook_accounts_add,
        );
      } else {
        fb = this.formDataToSend.facebook_accounts;
      }

      const data = {
        name: this.formDataToSend.name,
        email: this.formDataToSend.email,
        password: this.formDataToSend.password,
        facebook_accounts: fb,
      };

      if (!this.bayer) {
        if (!this.$route.query.team) {
          if (this.formDataToSend.group) {
            data.groups = [this.formDataToSend.group];
          } else {
            data.groups = [];
          }
        } else {
          data.team_id = this.$route.query.team;
        }

        if (this.can_edit_tag && (this.isCreateBayer() || this.formDataToSend.group == 3)) {
          data.buyer_tag = this.formDataToSend.buyer_tag;
        }
      }

      if (!this.bayer) {
        this.$store.dispatch("users/editUser", { url: url, editData: data });
      } else {
        this.$store.commit("users/setLoading", true);
        const keptFb = fb.map(String);
        const bayerFb = {
          facebook_accounts: fb,
          facebook_accounts_delete: this.initialFacebookAccounts.filter(
            (id) => !keptFb.includes(String(id)),
          ),
        };

        try {
          userApi
            .editUserFb("", bayerFb)
            .then((res) => {
              location.reload();
              this.$store.commit("users/setLoading", false);
            })
            .catch((error) => {
              const { data } = error.response;
              this.$store.commit("users/setError", data);
              if (data.errors) {
                console.log(data.errors);
                this.$store.commit("users/setValidationErrors", data.errors);
              }
              this.$store.commit("users/setLoading", false);
            });
        } catch (error) {}
      }
    },
    handleBackToList() {
      if (this.$route.query.team) {
        this.$router.push({
          path: ROUTE.TEAM_DETAIL.replace(":id", this.$route.query.team).replace(":page", 1),
        });
      } else {
        this.$router.push({
          path: ROUTE.USER_LIST.replace(":page", 1),
        });
      }
    },
    getItem() {
      const url = `/${this.getId}?with[0]=groups`;
      try {
        userApi.getItemUser(url).then((res) => {
          this.$store.commit("users/setError", {});
          this.$store.commit("users/setValidationErrors", {});
          const data = res.data;
          this.data = data;
          this.formDataToSend.name = data.name;
          this.formDataToSend.email = data.email;
          this.formDataToSend.buyer_tag = data.buyerTag || "";

          if (data.groups.length) {
            this.formDataToSend.group = data.groups[0].id;
          }

          this.initialFacebookAccounts = data.facebookAccounts.map((account) => account.accountId);

          if (data.facebookAccounts.length > 0) {
            this.formDataToSend.facebook_accounts = [];
            data.facebookAccounts.forEach((account) => {
              this.formDataToSend.facebook_accounts.push(account.accountId);
            });
          } else {
            this.formDataToSend.facebook_accounts.push("");
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    getGroup() {
      this.$store.commit("users/setLoading", true);
      userApi
        .getUserGroupList()
        .then((res) => {
          this.$store.commit("users/setLoading", false);
          if (res.success) {
            this.groupList = res.data.items;
          }
        })
        .catch((error) => {
          this.$store.commit("users/setLoading", false);
          console.log(error);
        });
    },
    addField() {
      this.formDataToSend.facebook_accounts.push("");
    },
    deleteField(index) {
      this.formDataToSend.facebook_accounts.splice(index, 1);
    },
    addFieldBayer() {
      this.formDataToSend.facebook_accounts_add.push("");
    },
    deleteFieldBayer(index) {
      this.formDataToSend.facebook_accounts_add.splice(index, 1);
    },
    handlePaste(e, index) {
      const values = e.clipboardData
        .getData("text")
        .split(/\s+/)
        .map((v) => v.replace(/\D/g, ""))
        .filter(Boolean);

      if (values.length <= 1) return;

      e.preventDefault();

      this.formDataToSend.facebook_accounts.splice(
        index,
        1, // удалить только текущий элемент
        ...values, // вставить все новые
      );
    },
    handlePasteAdd(e, index) {
      const values = e.clipboardData
        .getData("text")
        .split(/\s+/)
        .map((v) => v.replace(/\D/g, ""))
        .filter(Boolean);

      if (values.length <= 1) return;

      e.preventDefault();

      this.formDataToSend.facebook_accounts_add.splice(
        index,
        1, // удалить только текущий элемент
        ...values, // вставить все новые
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.input-select {
  max-width: 300px;
}
.checkbox-container {
  @include scrollBar;

  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 20px;

  &_margin {
    margin-top: 20px;
  }
}
.checkbox-container__item {
  padding: 5px 0;
}
.item {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 2fr 2fr 1fr;
  padding: 10px 15px;
  margin-bottom: 10px;
  background: gainsboro;
  border-radius: 10px;
}
.item-button {
  padding: 10px;
  border-radius: 10px;
  background: #3c2a1e;
  color: #fff;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
}
.list-items {
  padding-top: 30px;
}
.list-items__title {
  padding: 20px 0;
  font-size: 24px;
  font-weight: 700;
}

.form-create {
  &__input-container {
    width: fit-content;
    position: relative;
  }
  &__delete-field {
    position: absolute;
    top: 6px;
    right: -50px;
    width: 36px;
    height: 36px;
    transform: rotate(45deg);
    background: gray;
    color: #fff;
    font-size: 36px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50px;
  }
  &__input {
    width: 400px;
    padding: 5px 0 15px;
    background: #e5e5e7;
    border-radius: 5px;
    height: 36px;
    border: none;
    outline: none;
    font-size: 16px;
    padding: 17px 0 16px 16px;
  }

  &__add-field {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 10px 15px;
    background: rgb(228, 228, 228);
    width: fit-content;
    border-radius: 5px;
    margin-bottom: 15px;

    span {
      display: block;
      width: 30px;
      height: 30px;
      font-size: 30px;
      background: grey;
      border-radius: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      margin-right: 10px;
    }
  }
}

/* Chrome, Safari, Edge */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}
</style>
